import { useTranslation } from 'react-i18next'
import { BitazzaText } from '../../../../components'
import { Col, Row, Space } from 'antd'
import { FC } from 'react'
import styles from './styles.module.scss'

interface Props {
    rewards?: prizeSeasonStatus[]
    onConfirmHandler: () => void
}

const TEMP_REWARDS = [
    {
        details:
            'https://btz-public.s3.ap-southeast-1.amazonaws.com/trade-simulator/nft/ss1/BTS-Reward-T1-Bronze.jpg',
        name: 'Legendary',
    },
    {
        details:
            'https://btz-public.s3.ap-southeast-1.amazonaws.com/trade-simulator/nft/ss1/BTS-Reward-T2-Silver.jpg',
        name: 'Silver',
    },
]
export const LinkedFdw: FC<Props> = ({ rewards, onConfirmHandler }) => {
    const { t } = useTranslation()

    return (
        <div className={styles.mainNft}>
            <BitazzaText
                color="#FFFFFF"
                content={t('CONGRATULATIONS!')}
                format="t28"
                bold
            />
            <Row justify="center" className={styles.ntWrapper}>
                {rewards && rewards.length
                    ? rewards.map((rew, index) => {
                          if (rew.detail.nft_type !== 'Medal') {
                              return (
                                  <Col key={index} span={12}>
                                      <Space direction="vertical" size={0}>
                                          <div className={styles.nftImage}>
                                              <img
                                                  src={rew.detail.image_url}
                                                  alt="rewards"
                                                  width={68}
                                                  style={{
                                                      paddingBottom: '8px',
                                                  }}
                                              />
                                          </div>

                                          <BitazzaText
                                              content={rew.detail.nft_name}
                                              color={'#FFFFFF'}
                                              format={'t18'}
                                              textAlign="center"
                                          />
                                      </Space>
                                  </Col>
                              )
                          }
                      })
                    : null}
            </Row>
            <div className={styles.nftText}>
                <BitazzaText
                    color="#86A1A1"
                    textAlign="center"
                    format={'t16'}
                    content={t(
                        'The following NFTS has been sent to your Freedom World wallet. Please check your NFT wallet inside your Freedom World App.'
                    )}
                />
            </div>

            <div className={styles.nftText}>
                <BitazzaText
                    color="#86A1A1"
                    textAlign="center"
                    format={'t16'}
                    content={t(
                        'If you have not received your NFTs please contact customer service.'
                    )}
                />
            </div>
            <div
                className={styles.confirmButton}
                onClick={onConfirmHandler}
                style={{ marginTop: '20px', marginBottom: '16px' }}
            >
                <BitazzaText format="t18" color="#000" content={t('Ok')} bold />
            </div>

            <a
                href="https://bitazza.onelink.me/lhpw/hrvgisor"
                style={{
                    fontSize: '18px',
                    color: '#F1D87E',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                }}
            >
                {t('Go to Freedom World')}
            </a>
        </div>
    )
}
